import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '@constants/colors';
import { makeStyles } from 'tss-react/mui';
import { Avatar, Icon } from '@mui';

const useAvatarStyles = makeStyles()(theme => ({
  small: {
    backgroundColor: colors.coordinate.blue,
    fontSize: '0.875rem',
    width: theme.spacing(3),
    height: theme.spacing(3)
  },
  medium: {
    backgroundColor: colors.coordinate.blue,
    fontSize: '1rem',
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  large: {
    backgroundColor: colors.coordinate.blue,
    fontSize: '1.25rem',
    width: theme.spacing(5),
    height: theme.spacing(5)
  },
  giant: {
    backgroundColor: colors.coordinate.blue,
    fontSize: '2.5rem',
    width: theme.spacing(10),
    height: theme.spacing(10)
  }
}));

const ICON_FONT_SIZE = {
  small: '1rem',
  medium: '1.125rem',
  large: '1.5rem',
  giant: '2.75rem'
};

const NoUserIcon = ({ size = 'medium' }) => {
  const { classes: avatarClasses } = useAvatarStyles();
  return (
    <Avatar className={avatarClasses[size]} aria-hidden="true">
      {/* Our own Icon wrapper hardcodes its own 24px default via a separate tss-react class —
          passing the size override as a className (a second, independent same-specificity
          class) meant whichever one's style happened to get inserted last won, which isn't
          deterministic across renders. Icon.js's `style` prop merges directly into its own
          rule instead, so this always wins regardless of insertion order. */}
      <Icon style={{ fontSize: ICON_FONT_SIZE[size] }} color={colors.neutral.white}>location_on</Icon>
    </Avatar>
  );
};

NoUserIcon.propTypes = {
  size: PropTypes.string
};

export default NoUserIcon;
